<div class="wrap" [class.is-active]="focused || element.value">
  <input
    placeholder="Поиск..."
    #element
    (focus)="focused = true"
    (blur)="focused = false"
    (keyup)="keyUp.next(element.value)"
  />
</div>
